export default __webpack_public_path__ + "static/cog-white-cdb8f4c677cf7190fadff3f9585e3515.svg";